<template>
  <v-list-item two-line class="account-logo">
    <v-list-item-avatar min-width="48" min-height="48">
      <v-img
        :src="account.profilePicture || require('@/assets/images/default-avatar.png')"
        @error="account.profilePicture = require('@/assets/images/default-avatar.png')" />
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>{{ fullName }}</v-list-item-title>
      <v-list-item-subtitle><slot name="subTitle"></slot></v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { sanitizeAccount } from '@/common/helpers/sanitizeAcc';

export default {
  name: 'AccountLogo',
  props: {
    account: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    fullName() {
      return sanitizeAccount(this.account);
    },
  },
};
</script>

<style lang="scss">
  @import "src/assets/style/shared/AccountLogo";
</style>
